import { useFormikContext } from 'formik';
import { useCallback, useState } from 'react';

import ErrorMessage from 'components/common/ErrorMessage';
import PaypalButton from 'components/common/PaypalButton';
import { paymentError } from 'lib/constants/paymentErrors';
import { BRAINTREE } from 'lib/constants/payments';
import { getPaypalToken } from 'services/RequestService/endpoints/user';

const PayPalCheckout = ({ setPayPalDetails, onPaypalClick }) => {
  const { resetForm, values } = useFormikContext();
  const [errorMessage, setErrorMessage] = useState('');

  const handlePayPalUpdate = useCallback(
    payPalDetails => {
      setErrorMessage('');
      setPayPalDetails(payPalDetails);
      resetForm({ values: { ...values, vendor: BRAINTREE } });
      return { ok: true };
    },
    [setPayPalDetails, resetForm, values]
  );

  const handlePayPalClick = useCallback(() => {
    setErrorMessage('');
    onPaypalClick?.();
  }, [onPaypalClick]);

  const handlePayPalError = useCallback(() => {
    setErrorMessage(paymentError('PayPal'));
  }, []);

  return (
    <>
      {errorMessage && <ErrorMessage message={errorMessage} />}
      <PaypalButton
        onUpdatePayment={handlePayPalUpdate}
        onGetPaypalToken={getPaypalToken}
        styles={{
          layout: 'horizontal',
          shape: 'pill',
          label: 'paypal',
          height: 50,
        }}
        skeletonVariant="fullWidth"
        containerClass="w-full flex justify-center items-center"
        buttonClass="w-full"
        onPaypalClick={handlePayPalClick}
        onErrorMessage={handlePayPalError}
      />
    </>
  );
};

PayPalCheckout.propTypes = {
  setPayPalDetails: PropTypes.func.isRequired,
  onPaypalClick: PropTypes.func.isRequired,
};

export default PayPalCheckout;
